export default __webpack_public_path__ + "static/media/SolarSystem_15.149c9a1f.png";